import * as React from "react";
import { Row, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { timestampToMoment } from "src/share/utils/utils";
import { INotification } from "src/modules/Auth/store/types";

export interface INotificationProps {
  notification: INotification;
}

export class NotificationAlert extends React.Component<INotificationProps>{
  constructor(props: INotificationProps) {
    super(props);
  }

  public render() {
    const { notification } = this.props;
    const date = timestampToMoment(notification.date);
    return (
      <div className="notification">
        <NavLink to={`/alerts/edit/${notification.caseId}/${notification.alertId}`} tag={RRNavLink} >
          <Row>
            <div className="dateContainer">
              <p className="date">{date.date()}</p>
              <p className="month">{date.format('MMMM')}</p>
              <p className="day">{date.format('ddd')}</p>
            </div>
            <div className="notificationContainer">
              <h5 className="title">{notification.title}</h5>
              <p className="subTitle subFont">{notification.subTitle}</p>
              {notification.radius && <p className="extra subFont">{notification.radius}milles radius</p>}
            </div>
          </Row>
        </NavLink>
      </div>
    );
  }
}